import React from "react";

const Conditions = () => {
  return (
    <div className="flex flex-col items-start  sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide mx-auto">
        <span className="text-[#01A7D1]">Terms </span>and Conditions
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        This document is an electronic record in terms of Information Technology
        Act, 2000 and rules thereunder as applicable and the amended provisions
        pertaining to electronic records in various statutes as amended by the
        Information Technology Act, 2000. This electronic record is generated by
        a computer system and does not require any physical or digital
        signatures.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        This document is published in accordance with the provisions of Rule
        3(1) of Information Technology (Intermediaries guidelines) Rules, 2011
        that require publishing the rules and regulations, privacy policy and
        Terms of Use for access or usage of through the domain and subdomains of
        Yostel located at www.yostelhostel.com and/or through “Yostel – Student
        or Working Professional Residence Community” mobile applications
        (collectively referred to herein as the "Platform").
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        The Platform is owned by Yostel (under the brand name "Yostel"). Yostel
        operates, controls and manages the Services (as defined below) provided
        by it from its corporate office at 21st Floor, Ireo Grand View Tower,
        Golf Course Extension Road, Sector 58, Gurugram, Haryana 122102
        (“Corporate Office”) and registered office at 210 /C-1/1, 2nd Floor
        Amber Tower, Commercial Complex, Azadpur, New Delhi (North West)- 110033
        (hereinafter referred to as "Yostel").
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        This Terms of Use agreement was last updated on25 June, 2022.
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        This Terms of Use agreement is effective as of February 09, 2018.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        Definitions:
        <br />
        “Data” means a representation of information, knowledge, facts, concepts
        or instructions which are being prepared or have been prepared in a
        formalised manner, and is intended to be processed, is being processed
        or has been processed in a computer system or computer network, and may
        be in any form (including computer printouts magnetic or optical storage
        media, punched cards, punched tapes) or stored internally in the memory
        of the computer;
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        “Information” includes data, message, text, images, sound, voice, codes,
        computer programmes, software and data bases or microfilm or
        computer-generated microfiche.
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        "Password" means a secret word or phrase or code or passphrase or secret
        key, or encryption or decryption keys that one uses to gain admittance
        or access to information.
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        "Personal information" means any information that relates to a natural
        person, which, either directly or indirectly, in combination with other
        information available or likely to be available with a body corporate,
        is capable of identifying such a person.
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        “Services” shall mean residence, accommodation including but not limited
        to housekeeping services, food services and other services while staying
        at Yostel hostels.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3 ">
        password
        <br />
        financial information such as Bank account or credit card or debit card
        or other payment instrument details
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        physical, physiological and mental health condition
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        sexual orientation
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        medical records and history
      </p>
      <p className="text-md text-[#444444] tracking-wide pt-3 ">
        Biometric information
      </p>
    </div>
  );
};

export default Conditions;
